export const Dates = [
    {day: '2025/12/01', image: 'assets/days/1.png'},
    {day: '2025/12/02', image: 'assets/days/2-mobil.png'},
    {day: '2025/12/03', image: 'assets/days/3.png'},
    {day: '2025/12/04', image: 'assets/days/4.png'},
    {day: '2025/12/05', image: 'assets/days/5-mobil.png'},
    {day: '2025/12/06', image: 'assets/days/6.png'},
    {day: '2025/12/07', image: 'assets/days/7.png'},
    {day: '2025/12/08', image: 'assets/days/8.png'},
    {day: '2025/12/09', image: 'assets/days/9.png'},
    {day: '2025/12/10', image: 'assets/days/10.png'},
    {day: '2025/12/11', image: 'assets/days/11-mobil.png'},
    {day: '2025/12/12', image: 'assets/days/12.png'},
    {day: '2025/12/13', image: 'assets/days/13.png'},
    {day: '2025/12/14', image: 'assets/days/14.png'},
    {day: '2025/12/15', image: 'assets/days/15.png'},
    {day: '2025/12/16', image: 'assets/days/16-mobil.png'},
    {day: '2025/12/17', image: 'assets/days/17.png'},
    {day: '2025/12/18', image: 'assets/days/18.png'},
    {day: '2025/12/19', image: 'assets/days/19.png'},
    {day: '2025/12/20', image: 'assets/days/20.png'},
    {day: '2025/12/21', image: 'assets/days/21-mobil.png'},
    {day: '2025/12/22', image: 'assets/days/22-mobil.png'},
    {day: '2025/12/23', image: 'assets/days/23.png'},
    {day: '2025/12/24', image: 'assets/days/24.png'},];


export const desktopDates = [
    {day: '2025/12/16', image: 'assets/days/16.png', rowSpan: 1, colSpan: 2},
    {day: '2025/12/20', image: 'assets/days/20.png', rowSpan: 1, colSpan: 1},
    {day: '2025/12/21', image: 'assets/days/21.png', rowSpan: 1, colSpan: 2},
    {day: '2025/12/13', image: 'assets/days/13.png', rowSpan: 1, colSpan: 1},
    {day: '2025/12/12', image: 'assets/days/12.png', rowSpan: 1, colSpan: 1},
    {day: '2025/12/02', image: 'assets/days/2.png', rowSpan: 2, colSpan: 1},
    {day: '2025/12/09', image: 'assets/days/9.png', rowSpan: 1, colSpan: 1},
    {day: '2025/12/06', image: 'assets/days/6.png', rowSpan: 1, colSpan: 1},
    {day: '2025/12/04', image: 'assets/days/4.png', rowSpan: 1, colSpan: 1},
    {day: '2025/12/11', image: 'assets/days/11.png', rowSpan: 2, colSpan: 1},
    {day: '2025/12/10', image: 'assets/days/10.png', rowSpan: 1, colSpan: 1},
    {day: '2025/12/03', image: 'assets/days/3.png', rowSpan: 1, colSpan: 1},
    {day: '2025/12/23', image: 'assets/days/23.png', rowSpan: 1, colSpan: 1},
    {day: '2025/12/15', image: 'assets/days/15.png', rowSpan: 1, colSpan: 1},
    {day: '2025/12/19', image: 'assets/days/19.png', rowSpan: 1, colSpan: 1},
    {day: '2025/12/22', image: 'assets/days/22.png', rowSpan: 1, colSpan: 2},
    {day: '2025/12/08', image: 'assets/days/8.png', rowSpan: 1, colSpan: 1},
    {day: '2025/12/05', image: 'assets/days/5.png', rowSpan: 1, colSpan: 2},
    {day: '2025/12/01', image: 'assets/days/1.png', rowSpan: 1, colSpan: 1},
    {day: '2025/12/14', image: 'assets/days/14.png', rowSpan: 1, colSpan: 1},
    {day: '2025/12/17', image: 'assets/days/17.png', rowSpan: 1, colSpan: 1},
    {day: '2025/12/24', image: 'assets/days/24.png', rowSpan: 1, colSpan: 1},
    {day: '2025/12/18', image: 'assets/days/18.png', rowSpan: 1, colSpan: 1},
    {day: '2025/12/07', image: 'assets/days/7.png', rowSpan: 1, colSpan: 1},
]
